import React from 'react';

export function DocumentationIcon({ size = 48 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M38.148 14.5623V41.2941H9.85156V6.70587H30.2916L38.148 14.5623Z" stroke="#44B58F" strokeWidth="2" strokeMiterlimit="10" />
      <path d="M38.1466 14.5623V16.1435H28.709V6.70587H30.2902L38.1466 14.5623Z" stroke="#44B58F" strokeWidth="2" strokeMiterlimit="10" />
      <path d="M22.4336 25.5647H25.563" stroke="#44B58F" strokeWidth="2" strokeMiterlimit="10" />
      <path d="M28.709 25.5647H31.8549" stroke="#44B58F" strokeWidth="2" strokeMiterlimit="10" />
      <path d="M16.1426 25.5647H19.2885" stroke="#44B58F" strokeWidth="2" strokeMiterlimit="10" />
    </svg>
  );
}
